
const VCITA_DEFAULT = {
  use_login_with_code: true,
  hide_sign_up: false,
  logo_path: () => import('@/assets/images/vcita-logo-white.svg'),
  new_logo_path: () => import('@/assets/images/new-vcita-logo.svg')
}

const VCITA_DEFAULT_COLORS = {
  primary_color: "#0c315e",
  secondary_color: "#0093B8",
  text_color: "#ffffff",
  brand_color: "#4DA51E"
}

const isWhite = (color) => {
  return color === '#ffffff' || color === 'rgb(255, 255, 255)'
}

const state = {
  branding: {}
};

const getters = {
    branding: state => state.branding,
    secondaryColor: state => state.branding && state.branding.secondary_color || VCITA_DEFAULT_COLORS.secondary_color,
    primaryColor: state => state.branding && state.branding.primary_color || VCITA_DEFAULT_COLORS.primary_color,
    textColor: state => state.branding && state.branding.text_color || VCITA_DEFAULT_COLORS.text_color,
    isSecondaryColorSet: (state, getters) => !!getters.secondaryColor,
    hoverColor: (state, getters) => isWhite(getters.secondaryColor) ? getters.textColor : getters.secondaryColor,
    brandColor: state => state.branding.brand_color || VCITA_DEFAULT_COLORS.brand_color,
    isBranded: state => state.branding && (state.branding.whitelabel || state.branding.co_branded_managed)
};

const mutations = {
  setBrand: (state, brand) => {
    state.branding = brand;
  }
};

const actions = {
  initBrand: ({commit}, {brand}) => {
    brand = brand || {}
    const brandObj = (brand.whitelabel || brand.co_branded_managed) ? brand : {...brand, ...VCITA_DEFAULT}
    commit("setBrand", brandObj);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
